<template>
  <div>
    <div>
      <div class="registration-head text-center" style="background:#006C6B">
        <div class="sml-container">
          <div class="rg-head">
            <h1>キャリア登録内容の確認</h1>
          </div>
        </div>
      </div>
      <div class="sml-container">
        <div class="rgst-sec pt-0">
          <!-- <div class="career-rgst d-flex">
            <img src="../assets/images/BloomLogoNew.svg" class="w-100"/>
          </div> -->
          <div class="rgst-dtl-sec mt-4">
            <BProfilePreview :registrationEndpoint="'bloomRegister'" @redirectToRegistrationPage="redirectToRegistrationPage"/>
          </div>
          <!-- ends rgst-dtl-sec -->
        </div>
        <!-- ends rgst-sec -->
      </div>
    </div>
    <!-- ends main-area -->
  </div>
</template>
<script>
/* eslint-disable */
import { mapActions, mapGetters, mapMutations } from "vuex";
import BProfilePreview from "./BProfilePreview.vue";

export default {
  name: "profilePreview",
  components: { BProfilePreview },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions({
      setBloomData: "setBloomData",
    }),
    redirectToRegistrationPage() {
      this.$router.push({
        name: "bloomRegistration",
        // params: { slug: this.$route.params.slug }
      });
    },
    scrollToTop() {
      const element = document.getElementsByClassName("main-wrapper")[0];
      if (element) {
        element.scrollIntoView();
      }
    },
  },
  async mounted() {
    this.scrollToTop();
    await this.setBloomData(true);
    // this.photoPreview();
    // const check = await this.checkCompany(this.$route.params.slug);
    // if (!check) this.$router.push({ name: "Maintenance" });
  },
};
</script>
<style scoped>
.pt-0{
  padding-top: 0px;
}
.registration-head {
  display: flex;
  justify-content: center;
  align-items: center;
}
.rg-head {
  display: flex;
  align-items: center;
}
</style>
